module.exports = __webpack_public_path__ + "static/ht-logo-ed5181e62bbd374c36c797cc83b9e090.png";